module.exports = __webpack_public_path__ + "img/meeting-room_white.8257bbe2.svg";